// @flow
import UGC from './Ugc';
import Product from './Product';
import ModerationState from './ModerationState';
import Observation from './Observation';

export { default as Product } from './Product';
export { default as Review } from './Review';
export { default as Response } from './Response';
export { default as Image } from './Image';
export { default as Video } from './Video';
export { default as Question } from './Question';
export { default as Answer } from './Answer';
export { default as WhyDidYouBuy } from './WhyDidYouBuy';
export { default as Observation } from './Observation';
export { default as ModerationState } from './ModerationState';
export { default as UGC } from './Ugc';
export { default as Ugcs } from './Ugc';
export { default as ClientSpecificQuestion } from './ClientSpecificQuestion';
export { default as Catalog } from './Catalog';

// we want to remove the SSC observation
// when a ugc does not have service comments
export const removeIrrelevantSSCObservation = (
  datum: ContentBlob
): ContentBlob => {
  if (!datum.ugc.service_comments) {
    datum.pwr_observations = datum.pwr_observations.filter(
      code => code !== Observation.ShowServiceComment
    );
  }

  return datum;
};

export const createModels = (
  data: GetContentResponse,
  observationsMap: void | *
) => {
  const datum = removeIrrelevantSSCObservation(
    Array.isArray(data) ? data[0] : data
  );

  // not all UGC types are returned with subject_ids
  datum.ugc.subject_id = datum.subject.subject_id;

  const ugc = UGC.createWithData(datum);
  const ugcId = UGC.getId(ugc);
  const subject = Product.createWithData(datum); //TODO create object in saga
  const subjectId = datum.subject.subject_id;

  const moderationState =
    observationsMap != null
      ? ModerationState.create(observationsMap, datum)
      : null;

  return { ugc, ugcId, subject, subjectId, moderationState };
};



// WEBPACK FOOTER //
// ./src/models/index.js